"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeckCompositionSchema = void 0;
const zod_1 = require("zod");
// Used to update decks from client to server
const DeckCompositionSchema = zod_1.z.object({
    name: zod_1.z.string(),
    animatorId: zod_1.z.string(),
    cards: zod_1.z.array(zod_1.z.number()),
});
exports.DeckCompositionSchema = DeckCompositionSchema;
